import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import AppointmentRow from './AppointmentRow';

const actionsFor = (status) => {
  if (status === 'confirmed') {
    return [
      { status: 'arrived', label: 'Arrived' },
      { status: 'completed', label: 'Complete' },
      { status: 'cancelled', label: 'Cancel', danger: true },
      { status: 'no_show', label: 'No show', danger: true },
    ];
  }
  if (status === 'arrived') {
    return [{ status: 'completed', label: 'Checkout', primary: true }];
  }
  return [];
};

const TodayAppointments = ({ appointments, currency, onStatusChange }) => {
  // Keep the floor list actionable — completed visits live under Checkout / Till.
  // Newest first so a live demo booking lands at the top of Open now.
  const openAppointments = appointments
    .filter((appt) => appt.status === 'confirmed' || appt.status === 'arrived')
    .sort(
      (a, b) =>
        (b.createdAt || b.updatedAt || b.startAt || 0) -
        (a.createdAt || a.updatedAt || a.startAt || 0)
    );

  if (openAppointments.length === 0) {
    return (
      <div className="bg-sand-50 px-5 py-14 text-center ring-1 ring-ink-900/10">
        <p className="font-display text-2xl font-light text-ink-900">No open appointments</p>
        <p className="mt-2 text-sm text-ink-700/70">
          Book someone in on the calendar, or share your booking link.
        </p>
        <Link
          to="/app/calendar"
          className="mt-6 inline-flex items-center gap-2 bg-saffron-500 px-4 py-3 text-sm font-semibold uppercase tracking-[0.12em] text-ink-900 transition-colors hover:bg-saffron-400"
        >
          <Plus className="h-4 w-4" />
          Open calendar
        </Link>
      </div>
    );
  }

  return (
    <div className="bg-sand-50 ring-1 ring-ink-900/10">
      <div className="border-b border-ink-900/10 px-4 py-3 sm:px-5">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-ink-600/60">
          Open now · {openAppointments.length}
        </p>
      </div>
      <ul className="divide-y divide-ink-900/10">
        {openAppointments.map((appt) => (
          <AppointmentRow
            key={appt.id}
            appointment={appt}
            currency={currency}
            onStatusChange={onStatusChange}
            actions={actionsFor(appt.status)}
          />
        ))}
      </ul>
    </div>
  );
};

export default TodayAppointments;
